export default "__VITE_ASSET__C7bX6h9j__";